import { render, staticRenderFns } from "./MovieComing.vue?vue&type=template&id=7d5c2d6c&"
import script from "./MovieComing.vue?vue&type=script&lang=js&"
export * from "./MovieComing.vue?vue&type=script&lang=js&"
import style0 from "./MovieComing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports